<template>
  <header class="header">
    <BackButton v-if="user.role_id != 99" class="header__left" />
    <div class="header-right">
      <Trip360Search v-if="canTrip360" class="header__search" />
      <NotificationToaster v-if="user.role_id != 99" />
      <NotificationButton v-if="user.role_id != 99" />

      <div v-if="user.role_id != 99" class="user-info pointer" @click="toggleDropdown">
        <div class="avatar">
          <img
            class="ring-gray-300 ring-1"
            src="@/assets/user-avatar.jpg"
          >
        </div>

        <div class="user-details">
          <h2 class="username text-gray-800">{{ user.name }}</h2>
          <p class="text-xs text-gray-400">{{ user.role.name }}</p>
        </div>

        <div class="dropdown-menu" @click.stop v-if="isDropdownOpen">
          <div class="dropdown-text">
            <p>Пользователь</p>
            <strong>{{ user.email }}</strong>
          </div>
          <div class="dropdown-line"></div>
          <ul>
            <li @click="goNotifications">Уведомления</li>
            <li @click="$router.push('/user-settings/'+user.id)">Настройки</li>
            <li @click="handleExit">Выход</li>
          </ul>
        </div>
      </div>

      <div v-else class="user-info">
        <div class="avatar">
          <img
            class="ring-gray-300 ring-1"
            src="@/assets/user.png"
          >
        </div>

        <div class="user-details pointer">
          <h2 @click="$router.push('/login')">Войти</h2>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { ref, computed } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import NotificationButton from '@/components/NotificationButton.vue'
import NotificationToaster from '@/components/NotificationToaster.vue'
import Trip360Search from '@/components/trip360/Trip360Search.vue'

export default {
  name: 'Header',
  components: { NotificationButton, NotificationToaster, Trip360Search },

  setup() {
    let isDropdownOpen = ref(false)

    const store = useStore()
    const router = useRouter()

    const handleExit = async () => {
      await store.dispatch('logout')
      isDropdownOpen.value = false
      router.push('/login')
    }

    const goNotifications = () => {
      isDropdownOpen.value = false
      router.push({ name: 'Notifications' })
    }

    const toggleDropdown = () => {
      isDropdownOpen.value = !isDropdownOpen.value
    }

    const handleClickOutside = (event) => {
      if (isDropdownOpen.value && !event.target.closest('.user-info')) {
        isDropdownOpen.value = false
      }
    }
    window.addEventListener('click', handleClickOutside)

    return {
      handleExit,
      goNotifications,
      isDropdownOpen,
      toggleDropdown,
      handleClickOutside,
      user: computed(() => store.state.user.user),
      isAuth: computed(() => store.state.user.authIsReady),
      canTrip360: computed(() => store.getters.hasPermission('trip360.view')),
    }
  },
}
</script>


<style scoped>
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-height: 70px;
  background-color: rgba(254, 254, 254, 1);
  padding: 20px;
  box-shadow: 1px 1px 1px rgba(102, 102, 102, 0.1);
  border-bottom: 2px solid;
  border-color: #e5e7eb;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
}

.header h1 {
  margin: 0;
}

.user-info {
  display: flex;
  align-items: center;
}


.avatar {
  width: 45px;
  height: 45px;
  border-radius: 50%;
  margin-right: 10px;
  border: 1px solid #888;
}


.pointer {
  cursor: pointer;
}

.user-details {
  display: flex;
  flex-direction: column;
}

.user-details h2 {
  margin: 0;
}

.text-gray-800 {
  --tw-text-opacity: 1;
  color: rgb(31 41 55);
}

.text-gray-400 {
    color: rgb(156 163 175);
}

.text-xs {
    font-size: .75rem;
    line-height: 1rem;
}

h1, h2, h3, h4, h5, h6 {
    font-size: inherit;
    font-weight: inherit;
}

img {
  width: 2.8rem;
  height: 2.7rem;
  border-radius: 9999px;
  padding: 0.25rem;
  margin-right: 1rem;
  max-width: 100%;
}

.dropdown-menu {
  display: block;
  position: absolute;
  width: min-content;
  margin-top: 11rem;
  right: 2.5rem;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 6px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  /* above navbar */
  z-index: 101;
}

.dropdown-text{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  padding-left: 1rem;
  padding-right: 1rem;
}


.dropdown-line {
  border-top: 1px solid rgba(204,204,204, 0.3);

}


.dropdown-menu ul {
  list-style: none;
}

.dropdown-menu li {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  padding-right: 1rem;
  cursor: pointer;
}

.dropdown-menu li:hover {
  background-color: rgba(79,70,229, 1);
  color: white;
}

.header__left {
  margin-right: 0.2rem;
}

@media screen and (max-width: 426px) {
  .main-app-shrunk .header {
    padding-left: 110px;
  }
  .main-app-shrunk .header__search {
    display: none;
  }
  .header__search {
    /* 313px navbar - 90px margin+padding */
    width: 223px;
    margin-left: 50px;
    margin-top: -12px;
    z-index: 101;
  }
}
@media screen and (max-width: 769px) {
  .header__left {
    display: none;
  }
}
</style>
